module.exports = __webpack_public_path__ + "9edc0f3eab400267f78d8f6908926a3e.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/dow_image_2_0.png
// module id = 153
// module chunks = 0